import { useEffect, useState } from 'react';

import TopicsSvc from '../../../../services/TopicsSvc';
import { defaultSentimentPeriod } from '../../../../data/directory/topics/topicsSentimentAnalysis';

import PeriodFilters from '../PeriodFilters';
import TopicClassBox from './TopicClassBox';
import Scrollable from '../../../Shared/Scrollable';
import ItemsScrollBar from '../../../Shared/ItemsScrollBar';
import ActiveTopicSection from './ActiveTopicSection';
import TopicClassesVideo from './TopicClassesVideo';
import Preloader from '../../../Preloader';

import Styles from './styles.module.scss';

const TopicClasses = () => {
  const [activePeriod, setActivePeriod] = useState(defaultSentimentPeriod);
  const [topicClassesData, setTopicClassesData] = useState({
    loading: true,
    data: [],
  });
  const [topicClassesTabs, setTopicClassesTabs] = useState({
    loading: true,
    data: [],
  });

  useEffect(() => {
    const callAPI = async () => {
      const data = await TopicsSvc.getTopicClasses();
      setTopicClassesData({
        loading: false,
        data,
      });

      const tabData = data.map((obj) => ({
        ...obj,
        content: obj.title,
      }));
      tabData[0].active = true;
      setTopicClassesTabs({
        loading: false,
        data: tabData,
      });
    };

    callAPI();
  }, []);

  const handlePeriodChange = (value) => {
    setActivePeriod(value);
  };

  const handleTopicTabClick = (id) => {
    setTopicClassesTabs({
      loading: false,
      data: topicClassesTabs.data.map((obj) => ({
        ...obj,
        active: obj.id === id,
      })),
    });
  };

  const activeTopicClass = topicClassesTabs.data.find((f) => f.active);

  return (
    <div className={Styles['topic-classes']}>
      <div className={Styles['topic-classes-header']}>
        <div className={Styles['topic-classes-header-title']}>Topic Classes</div>
        <PeriodFilters onFilterChange={handlePeriodChange} />
      </div>
      <div className={Styles['topic-classes-chart-body']}>
        {topicClassesData.loading ? (
          <Preloader loading top="unset" />
        ) : (
          <Scrollable
            className={Styles['topic-classes-slider-outer']}
            wrapperClassName={Styles['topic-classes-slider']}
            arrowClass={Styles['topic-classes-slider-arrow']}
            isAllowFull
          >
            {topicClassesData.data.map((topic) => (
              <TopicClassBox
                key={topic.id}
                topic={topic}
                activePeriod={activePeriod}
              />
            ))}
          </Scrollable>
        )}
      </div>
      <div className={Styles['topic-classes-section-body']}>
        <ItemsScrollBar
          data={topicClassesTabs.data}
          onClick={handleTopicTabClick}
          withUnderline
          scrollToSelected
          className={Styles['topic-classes-section-tabs']}
          itemClassName={Styles['topic-classes-section-tabs-tab']}
          arrowClassName={Styles['topic-classes-section-tabs-arrow']}
        />
        {activeTopicClass && (
          <ActiveTopicSection
            topic={activeTopicClass}
            activePeriod={activePeriod}
          />
        )}
      </div>
      <TopicClassesVideo />
    </div>
  );
};

export default TopicClasses;
